import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=5985a214&scoped=true&"
import script from "./NotificationsView.vue?vue&type=script&lang=ts&"
export * from "./NotificationsView.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsView.vue?vue&type=style&index=0&id=5985a214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5985a214",
  null
  
)

component.options.__file = "NotificationsView.vue"
export default component.exports